import CIMSTable from 'components/CIMSTable'
import IFITrackerProvider, { useIFITrackerContext } from './IFITrackerContext'
import { useColumns } from './hooks/useColumns'
import { useExpand } from './hooks/useExpand'
import { usePayItems } from './hooks/usePayItems'
import PayItemSelectProvider from 'components/CIMSSelect/common/PayItemSelect/PayItemSelectContext'
import { useCustomHeaderActions } from './hooks/useCustomHeaderActions'
import { useEdit } from './hooks/useEdit'
import { ProjectCustomFieldsProvider } from 'components/CustomFields/ProjectCustomFieldsContext'
import { CSVEntity, CustomFieldClassType } from 'shared'
import ReviewModal from './components/ReviewModal'
import { useCustom } from './hooks/useCustom'
import RevertModal from './components/RevertModal'
import HelpIcon from 'components/HelpIcon'
import { useImportRulesHelpText } from './hooks/useImportRulesHelpText'
import IssueReportsSelectOptionsProvider from '../../IssueReportsSelectOptionsContext'
import EJReportsSelectOptionsProvider from '../../../EngineeringJudgements/components/EJReportsSelectOptionsContext'

const IFITrackerTable: React.FC = () => {
  const {
    loading,
    refetch: onReload,
    identifiedFieldIssues,
  } = useIFITrackerContext()
  return (
    <CIMSTable
      details={
        <HelpIcon text={useImportRulesHelpText()}>
          Identified Field Issues are periodically synced by inspecting various
          Report Types in the CIMS Field App
        </HelpIcon>
      }
      columns={useColumns()}
      records={identifiedFieldIssues}
      rowKey="reportId"
      loading={loading}
      actions={{
        header: {
          onReload,
          csv: CSVEntity.IdentifiedFieldIssue,
          custom: useCustomHeaderActions(),
          deepLinkKey: 'reportId',
          payItems: usePayItems(),
        },
        row: { edit: useEdit(), custom: useCustom() },
      }}
      expand={useExpand()}
    >
      <ReviewModal />
      <RevertModal />
    </CIMSTable>
  )
}

const IFITracker: React.FC = () => {
  return (
    <IssueReportsSelectOptionsProvider>
      <ProjectCustomFieldsProvider
        classType={CustomFieldClassType.IdentifiedFieldIssue}
      >
        <PayItemSelectProvider>
          <EJReportsSelectOptionsProvider>
            <IFITrackerProvider>
              <IFITrackerTable />
            </IFITrackerProvider>
          </EJReportsSelectOptionsProvider>
        </PayItemSelectProvider>
      </ProjectCustomFieldsProvider>
    </IssueReportsSelectOptionsProvider>
  )
}

export default IFITracker
